export default "/assets/mm_en.png";